import type { JsonLd } from '@atlaskit/json-ld-types';
import type { SmartLinkResponse } from '@atlaskit/linking-types';

const ATLASSIAN_PRODUCTS = new Set([
	'jira',
	'confluence',
	'bitbucket',
	'trello',
	'loom',
	'townsquare',
	'compass',
	'mercury',
	'atlas',
	'watermelon',
	'canvas',
	'rovo',
]);

export type SmartLinkRovoMetadata = {
	has3pSources: boolean;
	smartlinkName: string;
	sourceProduct: string | null;
};

const getHostnameFromUrl = (url: string): string => {
	try {
		return new URL(url).hostname;
	} catch {
		return '';
	}
};

export const getSmartLinkRovoMetadata = ({
	details,
	smartlinkUrl,
}: {
	details?: SmartLinkResponse;
	smartlinkUrl: string;
}): SmartLinkRovoMetadata => {
	const objectProviderKey = details?.meta?.key?.toLowerCase() ?? '';
	const hasObjectProviderKey = objectProviderKey.length > 0;
	const isThirdPartyNonPublic =
		!Array.from(ATLASSIAN_PRODUCTS).some((product) => objectProviderKey.includes(product)) &&
		!objectProviderKey.includes('public');

	const sourceProduct = hasObjectProviderKey ? objectProviderKey.split('-')[0] : null;
	const has3pSources = hasObjectProviderKey ? isThirdPartyNonPublic : false;
	// Extract the human-readable name from the SmartLink's JSON-LD data (the
	// `name` field on BaseData). Fall back to the URL hostname so the Rovo chat
	// context banner always has a non-empty label.
	const smartlinkData = details?.data as JsonLd.Data.BaseData | undefined;
	const smartlinkName =
		typeof smartlinkData?.name === 'string' && smartlinkData.name
			? smartlinkData.name
			: getHostnameFromUrl(smartlinkUrl);

	return {
		has3pSources,
		smartlinkName,
		sourceProduct,
	};
};
